import { FormModelsModule } from 'src/shared/form-models/form-models.module';
import { AddEditShiftDialogComponent } from './add-edit-shift-dialog.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/shared/material/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CurrencyInputModule } from 'src/shared/currency-input/currency-input.module';
import { AlertsModule } from 'src/shared/alerts/alerts.module';
import { SharedGlobalModule } from 'src/shared/shared-global.module';
import { TextMaskModule } from 'angular2-text-mask';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        FlexLayoutModule,
        CurrencyInputModule,
        AlertsModule,
        SharedGlobalModule,
        TextMaskModule,
        FormModelsModule,
    ],
    declarations: [AddEditShiftDialogComponent],
    exports: [AddEditShiftDialogComponent]
})
export class AddEditShiftsDialogModule {}
